// Form CRUD
export const GET_BOARD_FORMS = "Form/GET_BOARD_FORMS";
export const GET_FORM_BY_ID = "Form/GET_FORM_BY_ID";
export const CREATE_FORM = "Form/CREATE_FORM";
export const UPDATE_FORM = "Form/UPDATE_FORM";
export const SET_FORM_ARCHIVE = "Form/SET_FORM_ARCHIVE";
export const DELETE_FORM = "Form/DELETE_FORM";

// Task / TaskMap Form CRUD
export const CREATE_TASK_FORM = "Form/CREATE_TASK_FORM";
export const CREATE_TASK_MAP_FORM = "Form/CREATE_TASK_MAP_FORM";
export const UPDATE_TASK_FORM = "Form/UPDATE_TASK_FORM";
export const UPDATE_TASK_MAP_FORM = "Form/UPDATE_TASK_MAP_FORM";
export const DELETE_TASK_FORM = "Form/DELETE_TASK_FORM";
export const DELETE_TASK_MAP_FORM = "Form/DELETE_TASK_MAP_FORM";

// Form loading & error states
export const SET_FORMS_LOADING = "Form/SET_FORMS_LOADING";
export const SET_FORMS_ERROR = "Form/SET_FORMS_ERROR";
export const CLEAR_FORM_STATE = "Form/CLEAR_FORM_STATE";
export const CLEAR_CURRENT_FORM = "Form/CLEAR_CURRENT_FORM";

// Completed forms (submissions & reports)
export const GET_COMPLETED_FORMS = "Form/GET_COMPLETED_FORMS";
export const GET_COMPLETED_FORM_BY_ID = "Form/GET_COMPLETED_FORM_BY_ID";
export const SUBMIT_COMPLETED_FORM = "Form/SUBMIT_COMPLETED_FORM";
export const DELETE_COMPLETED_FORM = "Form/DELETE_COMPLETED_FORM";

// Completed forms loading & error states
export const SET_COMPLETED_FORMS_LOADING = "Form/SET_COMPLETED_FORMS_LOADING";
export const SET_COMPLETED_FORMS_ERROR = "Form/SET_COMPLETED_FORMS_ERROR";
export const CLEAR_COMPLETED_FORMS_STATE = "Form/CLEAR_COMPLETED_FORMS_STATE";
export const CLEAR_CURRENT_COMPLETED_FORM = "Form/CLEAR_CURRENT_COMPLETED_FORM";

export const GET_FORM_RESPONSE_STATS = "Form/GET_FORM_RESPONSE_STATS";
export const SET_FORM_RESPONSE_STATS_LOADING =
  "Form/SET_FORM_RESPONSE_STATS_LOADING";
export const SET_FORM_RESPONSE_STATS_ERROR = "Form/SET_FORM_RESPONSE_STATS_ERROR";
export const CLEAR_FORM_RESPONSE_STATS = "Form/CLEAR_FORM_RESPONSE_STATS";

// Section categories (Board.SectionCategories.Forms)
export const GET_FORM_CATEGORIES = "Form/GET_FORM_CATEGORIES";
export const SET_FORM_CATEGORIES_LOADING = "Form/SET_FORM_CATEGORIES_LOADING";
export const SET_FORM_CATEGORIES_ERROR = "Form/SET_FORM_CATEGORIES_ERROR";
export const GET_FORM_DEPARTMENTS = "Form/GET_FORM_DEPARTMENTS";
export const SET_FORM_DEPARTMENTS_LOADING = "Form/SET_FORM_DEPARTMENTS_LOADING";
export const SET_FORM_DEPARTMENTS_ERROR = "Form/SET_FORM_DEPARTMENTS_ERROR";
export const GET_FORM_STATUSES = "Form/GET_FORM_STATUSES";
export const SET_FORM_STATUSES_LOADING = "Form/SET_FORM_STATUSES_LOADING";
export const SET_FORM_STATUSES_ERROR = "Form/SET_FORM_STATUSES_ERROR";

// Public form (no auth - shared form fill page)
export const GET_PUBLIC_FORM_BY_ID = "Form/GET_PUBLIC_FORM_BY_ID";
export const SET_PUBLIC_FORM_LOADING = "Form/SET_PUBLIC_FORM_LOADING";
export const SET_PUBLIC_FORM_ERROR = "Form/SET_PUBLIC_FORM_ERROR";
export const CLEAR_PUBLIC_FORM = "Form/CLEAR_PUBLIC_FORM";
export const SUBMIT_PUBLIC_FORM = "Form/SUBMIT_PUBLIC_FORM";
export const SET_PUBLIC_FORM_SUBMIT_LOADING =
  "Form/SET_PUBLIC_FORM_SUBMIT_LOADING";
export const SET_PUBLIC_FORM_SUBMIT_ERROR = "Form/SET_PUBLIC_FORM_SUBMIT_ERROR";
export const GET_PUBLIC_FORM_RECORD = "Form/GET_PUBLIC_FORM_RECORD";
export const SET_PUBLIC_FORM_RECORD_LOADING =
  "Form/SET_PUBLIC_FORM_RECORD_LOADING";
export const SET_PUBLIC_FORM_RECORD_ERROR = "Form/SET_PUBLIC_FORM_RECORD_ERROR";
export const PUBLIC_FORM_RECORD_REPLY = "Form/PUBLIC_FORM_RECORD_REPLY";
export const REPLY_COMPLETED_FORM = "Form/REPLY_COMPLETED_FORM";
export const SET_COMPLETED_FORM_TICKET_STATUS =
  "Form/SET_COMPLETED_FORM_TICKET_STATUS";
export const SET_COMPLETED_FORM_WORKFLOW_STATE =
  "Form/SET_COMPLETED_FORM_WORKFLOW_STATE";
